// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region Responsive Framework */
/* #endregion */
/* #region Content Items */
/* #endregion */
/* #region Color Palette */
/* #region Border Radius */
/* #endregion */
/* #region Typography */
/* #endregion */
/* #region Button */
/* #endregion */
/* #region Z-Index */
/* #endregion */
/*
  The spacing function is a simple utility that takes a multiplier and returns the corresponding 
  spacing value based on the defined spacing step. This allows for easy adjustments to the overall 
  spacing of the app by simply changing the value of \$spacing-step.

  This is made only to mirror the spacing function in the design system.

  - MRA
*/
/*
  The breakpoint mixins are utilities for handling responsive design. They allow you to write media queries 
  in a more readable and maintainable way by using named breakpoints defined in the \$breakpoints map.

  - MRA
*/
/*
  Experimental

  There are now two distinct fluid helpers in this file:

  1. \`fluid-props(\$map, \$breakpoint)\`
     Keeps the existing behavior for a group of properties.
     Static values are emitted first, and inside \`respond-down(\$breakpoint)\`
     each property scales from the provided value down toward the \`sm\`
     breakpoint using the original proportional logic.

  2. \`fluid-prop-range(...)\`
     Handles a single property with three explicit values:
     - a base value, emitted outside any media query
     - a min value, used for scaling down from \`xl\` to \`sm\`
     - a max value, used for scaling up from \`xxl\` and above

     The downscale path is a direct interpolation between the explicit
     min and base values. The upscale path reuses the same proportional
     viewport logic as the original helper, anchored to the base value,
     and clamps the result so it never exceeds the explicit max value.

  - MRA
*/
/*
  Builds a clamp() expression from two explicit values and two explicit
  breakpoints.

  This is the low-level interpolation helper used when both endpoints are
  known, for example when a property should be exactly 24px at \`sm\` and
  exactly 40px at \`xl\`.
*/
/*
  Recreates the original proportional scaling logic used by \`fluid-prop\`.

  Only the upper value is supplied. The lower value is derived from the
  ratio between the provided maximum value and its controlling breakpoint,
  then passed through \`fluid-between()\` for the final clamp() expression.
*/
/*
  Scales upward from a base value using the same proportional viewport logic
  as the original helper, then clamps that growth to an explicit max value.

  The ratio is anchored to the base value and its reference breakpoint.
  In practice this means the property keeps its base value until the viewport
  is large enough for the preferred fluid expression to exceed it, after which
  it grows smoothly until the explicit max value is reached.
*/
/*
  Single-property helper for the three-value case.

  Output behavior:
  - Base value is emitted directly, outside any media query.
  - Inside \`respond-down(\$base-name)\`, the property scales from the explicit
    min value up to the base value.
  - If \`\$max-value\` is provided, inside \`respond-up(\$max-name)\` the property
    scales upward from the base value and is clamped so it never exceeds the
    explicit max value.
  - If \`\$max-value\` is omitted (or \`null\`), no upscale media query is emitted.

  Example:
  @include utils.fluid-prop-range(font-size, 40px, 24px, 56px);

  Example without max:
  @include utils.fluid-prop-range(font-size, 40px, 24px);
*/
/*
  Group-property helper for the original xl-to-sm scaling case.

  Output behavior:
  - Each property in the map is emitted first as a static base value,
    outside any media query.
  - Inside \`respond-down(\$breakpoint)\`, every property in the map is
    recalculated with the original proportional fluid logic so it scales
    down toward the \`sm\` breakpoint.

  This helper is intended for the existing multi-property scenario where a
  component has one shared upper breakpoint and each property should shrink
  proportionally beneath it.

  Examples:
  @include utils.fluid-props((margin-top: 64px, margin-left: 52px));
  @include utils.fluid-props((margin-top: 64px), \$breakpoint: lg);
*/
.program-sheet__JgVWS {
  transition: transform 0.3s ease-in-out;
  position: relative;
}
.program-sheet--focused__PFKKX {
  transform: translateY(-925px);
}
.program-sheet--scrollable__VV8jo {
  padding-bottom: 88px;
}
.browser-mode .program-sheet--scrollable__VV8jo {
  padding-bottom: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet--scrollable__VV8jo {
    padding-bottom: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-header__QJlcD {
  display: flex;
  flex-direction: column;
  height: 580px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
  height: calc(580px * 0.65);
}
.program-sheet__JgVWS .program-sheet-header__QJlcD {
  padding-bottom: 16px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
  padding-bottom: calc(16px * 0.65);
}
.program-sheet__JgVWS .program-sheet-header__QJlcD {
  padding-left: 88px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
  padding-left: calc(88px * 0.65);
}
.program-sheet__JgVWS .program-sheet-header__QJlcD {
  padding-right: 88px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
  padding-right: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
    height: clamp(calc(calc(580px * 0.65) * 0.4583333333), calc(calc(580px * 0.65) * 0.4583333333) + (calc(580px * 0.65) - calc(calc(580px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(580px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
    padding-bottom: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
    padding-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-header__QJlcD {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-header__title__I7qig {
  margin-top: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  min-width: 0;
}
.program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  margin-top: auto;
  flex-shrink: 0;
  border: 2.5px solid rgba(242, 242, 242, 0.2);
  box-shadow: 0px 10px 16px rgb(0, 0, 0);
  border-radius: 16px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  border-radius: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
    border-radius: clamp(calc(10.4px * 0.65), calc(10.4px * 0.65) + (calc(16px * 0.65) - calc(10.4px * 0.65)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  margin-bottom: 24px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  margin-bottom: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
    margin-bottom: clamp(calc(15.6px * 0.65), calc(15.6px * 0.65) + (calc(24px * 0.65) - calc(15.6px * 0.65)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  margin-right: 24px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  margin-right: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
    margin-right: clamp(calc(15.6px * 0.65), calc(15.6px * 0.65) + (calc(24px * 0.65) - calc(15.6px * 0.65)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  width: 157px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  width: calc(157px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
    width: clamp(calc(102.05px * 0.65), calc(102.05px * 0.65) + (calc(157px * 0.65) - calc(102.05px * 0.65)) * (100vw - 880px) / 1040px, calc(157px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  height: 234px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  height: calc(234px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-header__title-image__deSus {
    height: clamp(calc(152.1px * 0.65), calc(152.1px * 0.65) + (calc(234px * 0.65) - calc(152.1px * 0.65)) * (100vw - 880px) / 1040px, calc(234px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-header__title-image__deSus {
  min-width: 102.05px;
  min-height: 152.1px;
}
.program-sheet__JgVWS .program-sheet-header__title-text__ll37V {
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.program-sheet__JgVWS .program-sheet-content___C5D8 {
  display: flex;
  flex-direction: column;
}
.program-sheet__JgVWS .program-sheet-content__container__Fk9C_ {
  display: flex;
  padding-left: 88px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__container__Fk9C_ {
  padding-left: calc(88px * 0.65);
}
.program-sheet__JgVWS .program-sheet-content__container__Fk9C_ {
  padding-right: 88px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__container__Fk9C_ {
  padding-right: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__container__Fk9C_ {
    padding-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-content__container__Fk9C_ {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__missing-access__aeQ33 {
  font-weight: 700;
  font-size: 24px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__missing-access__aeQ33 {
  font-size: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__missing-access__aeQ33 {
    font-size: clamp(calc(calc(24px * 0.65) * 0.4583333333), calc(calc(24px * 0.65) * 0.4583333333) + (calc(24px * 0.65) - calc(calc(24px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__missing-access__aeQ33 {
  color: #ffdb38;
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ {
  display: flex;
  flex-direction: column;
  height: 335px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ {
  height: calc(335px * 0.65);
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ {
  width: 560px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ {
  width: calc(560px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ {
    height: clamp(calc(calc(335px * 0.65) * 0.4583333333), calc(calc(335px * 0.65) * 0.4583333333) + (calc(335px * 0.65) - calc(calc(335px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(335px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ {
    width: clamp(calc(calc(560px * 0.65) * 0.4583333333), calc(calc(560px * 0.65) * 0.4583333333) + (calc(560px * 0.65) - calc(calc(560px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(560px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-meta__tv__Qw_dJ {
  margin-top: -8px;
  overflow: hidden;
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-meta__browser__E1sZg {
  display: flex;
  align-items: center;
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj {
  position: relative;
  margin-top: 16px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj {
  margin-top: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj {
    margin-top: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__button__et8Rp {
  width: 100%;
  margin-top: 24px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__button__et8Rp {
  margin-top: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__button__et8Rp {
    margin-top: clamp(calc(calc(24px * 0.65) * 0.4583333333), calc(calc(24px * 0.65) * 0.4583333333) + (calc(24px * 0.65) - calc(calc(24px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj .browser-mode & .icon-button {
  height: 72px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj .browser-mode & .icon-button {
  height: calc(72px * 0.65);
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj .browser-mode & .icon-button {
  width: 72px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj .browser-mode & .icon-button {
  width: calc(72px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj .browser-mode & .icon-button {
    height: clamp(calc(calc(72px * 0.65) * 0.4583333333), calc(calc(72px * 0.65) * 0.4583333333) + (calc(72px * 0.65) - calc(calc(72px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(72px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__gJQfj .browser-mode & .icon-button {
    width: clamp(calc(calc(72px * 0.65) * 0.4583333333), calc(calc(72px * 0.65) * 0.4583333333) + (calc(72px * 0.65) - calc(calc(72px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(72px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__secondary--flex__sREBQ {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 40px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__secondary--flex__sREBQ {
  margin-top: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .sheet-buttons__secondary--flex__sREBQ {
    margin-top: clamp(calc(calc(40px * 0.65) * 0.4583333333), calc(calc(40px * 0.65) * 0.4583333333) + (calc(40px * 0.65) - calc(calc(40px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .progress__cuGPF {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .progress__bar__RSwLh {
  width: 100%;
  border-radius: 4px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .progress__bar__RSwLh {
  border-radius: calc(4px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .progress__bar__RSwLh {
    border-radius: clamp(calc(calc(4px * 0.65) * 0.4583333333), calc(calc(4px * 0.65) * 0.4583333333) + (calc(4px * 0.65) - calc(calc(4px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(4px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .progress__duration__n9tvI {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  white-space: nowrap;
  margin-left: 32px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .progress__duration__n9tvI {
  margin-left: calc(32px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__left-column__W2sxQ .progress__duration__n9tvI {
    margin-left: clamp(calc(calc(32px * 0.65) * 0.4583333333), calc(calc(32px * 0.65) * 0.4583333333) + (calc(32px * 0.65) - calc(calc(32px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(32px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un {
  margin-left: 184px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un {
  margin-left: calc(184px * 0.65);
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un {
  width: 1000px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un {
  width: calc(1000px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un {
    margin-left: clamp(calc(calc(184px * 0.65) * 0.4583333333), calc(calc(184px * 0.65) * 0.4583333333) + (calc(184px * 0.65) - calc(calc(184px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(184px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un {
    width: clamp(calc(calc(1000px * 0.65) * 0.4583333333), calc(calc(1000px * 0.65) * 0.4583333333) + (calc(1000px * 0.65) - calc(calc(1000px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(1000px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M:hover {
  cursor: pointer;
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M {
  border: 4px solid rgba(242, 242, 242, 0.2);
  box-sizing: border-box;
  height: auto;
  align-self: flex-start;
  width: 100%;
  transition: all 0.15s ease;
  border-radius: 8px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M {
  border-radius: calc(8px * 0.65);
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M {
  padding: 16px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M {
  padding: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M {
    border-radius: clamp(calc(calc(8px * 0.65) * 0.4583333333), calc(calc(8px * 0.65) * 0.4583333333) + (calc(8px * 0.65) - calc(calc(8px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(8px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M {
    padding: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description--focused__aQP_7, .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__Rts4M:hover {
  border-color: #f2f2f2;
  border-width: 4px;
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__info__xbj0P {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__info__xbj0P {
  margin-bottom: calc(20px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__info__xbj0P {
    margin-bottom: clamp(calc(calc(20px * 0.65) * 0.4583333333), calc(calc(20px * 0.65) * 0.4583333333) + (calc(20px * 0.65) - calc(calc(20px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(20px * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
  margin-bottom: 4px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
  margin-bottom: calc(4px * 0.65);
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
  margin-top: 16px;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
  margin-top: calc(16px * 0.65);
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
  font-weight: 700;
}
.browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
  font-weight: calc(700 * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
    margin-bottom: clamp(calc(calc(4px * 0.65) * 0.4583333333), calc(calc(4px * 0.65) * 0.4583333333) + (calc(4px * 0.65) - calc(calc(4px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(4px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
    margin-top: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
  .browser-mode .program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__headline__YzZHZ {
    font-weight: clamp(calc(calc(700 * 0.65) * 0.4583333333), calc(calc(700 * 0.65) * 0.4583333333) + (calc(700 * 0.65) - calc(calc(700 * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(700 * 0.65));
  }
}
.program-sheet__JgVWS .program-sheet-content__right-column__O45un .description__body__Chupx {
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.program-sheet__JgVWS .program-sheet-content__bottom-column__M_ksy {
  display: flex;
  justify-content: space-between;
}

.program-sheet-skeleton__QM_dm {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.program-sheet-skeleton__header__kMEeT {
  display: flex;
  align-items: flex-end;
  height: 580px;
}
.browser-mode .program-sheet-skeleton__header__kMEeT {
  height: calc(580px * 0.65);
}
.program-sheet-skeleton__header__kMEeT {
  padding-bottom: 40px;
}
.browser-mode .program-sheet-skeleton__header__kMEeT {
  padding-bottom: calc(40px * 0.65);
}
.program-sheet-skeleton__header__kMEeT {
  padding-left: 88px;
}
.browser-mode .program-sheet-skeleton__header__kMEeT {
  padding-left: calc(88px * 0.65);
}
.program-sheet-skeleton__header__kMEeT {
  padding-right: 88px;
}
.browser-mode .program-sheet-skeleton__header__kMEeT {
  padding-right: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__header__kMEeT {
    height: clamp(calc(calc(580px * 0.65) * 0.4583333333), calc(calc(580px * 0.65) * 0.4583333333) + (calc(580px * 0.65) - calc(calc(580px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(580px * 0.65));
  }
  .browser-mode .program-sheet-skeleton__header__kMEeT {
    padding-bottom: clamp(calc(calc(40px * 0.65) * 0.4583333333), calc(calc(40px * 0.65) * 0.4583333333) + (calc(40px * 0.65) - calc(calc(40px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
  .browser-mode .program-sheet-skeleton__header__kMEeT {
    padding-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .program-sheet-skeleton__header__kMEeT {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.program-sheet-skeleton__header-skeleton__yRr6Z {
  width: 42%;
  height: 64px;
}
.program-sheet-skeleton__content__KKMLl {
  display: flex;
  padding-left: 88px;
}
.browser-mode .program-sheet-skeleton__content__KKMLl {
  padding-left: calc(88px * 0.65);
}
.program-sheet-skeleton__content__KKMLl {
  padding-right: 88px;
}
.browser-mode .program-sheet-skeleton__content__KKMLl {
  padding-right: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__content__KKMLl {
    padding-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .program-sheet-skeleton__content__KKMLl {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.program-sheet-skeleton__actions__C11wZ {
  display: flex;
  flex-direction: column;
  width: 560px;
}
.browser-mode .program-sheet-skeleton__actions__C11wZ {
  width: calc(560px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__actions__C11wZ {
    width: clamp(calc(calc(560px * 0.65) * 0.4583333333), calc(calc(560px * 0.65) * 0.4583333333) + (calc(560px * 0.65) - calc(calc(560px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(560px * 0.65));
  }
}
.program-sheet-skeleton__action-label__hM4fG {
  width: 45%;
  height: 28px;
}
.program-sheet-skeleton__action-button__Lq3AJ {
  width: 100%;
  height: 72px;
  margin-top: 24px;
}
.browser-mode .program-sheet-skeleton__action-button__Lq3AJ {
  margin-top: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__action-button__Lq3AJ {
    margin-top: clamp(calc(calc(24px * 0.65) * 0.4583333333), calc(calc(24px * 0.65) * 0.4583333333) + (calc(24px * 0.65) - calc(calc(24px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.program-sheet-skeleton__secondary-actions__D6Jc6 {
  display: flex;
  margin-top: 24px;
}
.browser-mode .program-sheet-skeleton__secondary-actions__D6Jc6 {
  margin-top: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__secondary-actions__D6Jc6 {
    margin-top: clamp(calc(calc(24px * 0.65) * 0.4583333333), calc(calc(24px * 0.65) * 0.4583333333) + (calc(24px * 0.65) - calc(calc(24px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.program-sheet-skeleton__secondary-action__l716P {
  width: 72px;
  height: 72px;
}
.program-sheet-skeleton__secondary-action__l716P + .program-sheet-skeleton__secondary-action__l716P {
  margin-left: 24px;
}
.browser-mode .program-sheet-skeleton__secondary-action__l716P + .program-sheet-skeleton__secondary-action__l716P {
  margin-left: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__secondary-action__l716P + .program-sheet-skeleton__secondary-action__l716P {
    margin-left: clamp(calc(calc(24px * 0.65) * 0.4583333333), calc(calc(24px * 0.65) * 0.4583333333) + (calc(24px * 0.65) - calc(calc(24px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.program-sheet-skeleton__description__wqZak {
  display: flex;
  flex-direction: column;
  margin-left: 184px;
}
.browser-mode .program-sheet-skeleton__description__wqZak {
  margin-left: calc(184px * 0.65);
}
.program-sheet-skeleton__description__wqZak {
  padding: 20px;
}
.browser-mode .program-sheet-skeleton__description__wqZak {
  padding: calc(20px * 0.65);
}
.program-sheet-skeleton__description__wqZak {
  width: 1000px;
}
.browser-mode .program-sheet-skeleton__description__wqZak {
  width: calc(1000px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__description__wqZak {
    margin-left: clamp(calc(calc(184px * 0.65) * 0.4583333333), calc(calc(184px * 0.65) * 0.4583333333) + (calc(184px * 0.65) - calc(calc(184px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(184px * 0.65));
  }
  .browser-mode .program-sheet-skeleton__description__wqZak {
    padding: clamp(calc(calc(20px * 0.65) * 0.4583333333), calc(calc(20px * 0.65) * 0.4583333333) + (calc(20px * 0.65) - calc(calc(20px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(20px * 0.65));
  }
  .browser-mode .program-sheet-skeleton__description__wqZak {
    width: clamp(calc(calc(1000px * 0.65) * 0.4583333333), calc(calc(1000px * 0.65) * 0.4583333333) + (calc(1000px * 0.65) - calc(calc(1000px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(1000px * 0.65));
  }
}
.program-sheet-skeleton__description-heading__bOdyT {
  width: 32%;
  height: 32px;
}
.program-sheet-skeleton__description-line__CtR6R, .program-sheet-skeleton__description-line--short__QFeRn, .program-sheet-skeleton__description-line--wide__GYeAE, .program-sheet-skeleton__description-line--full__W4ln0 {
  margin-top: 16px;
}
.browser-mode .program-sheet-skeleton__description-line__CtR6R, .browser-mode .program-sheet-skeleton__description-line--short__QFeRn, .browser-mode .program-sheet-skeleton__description-line--wide__GYeAE, .browser-mode .program-sheet-skeleton__description-line--full__W4ln0 {
  margin-top: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .program-sheet-skeleton__description-line__CtR6R, .browser-mode .program-sheet-skeleton__description-line--short__QFeRn, .browser-mode .program-sheet-skeleton__description-line--wide__GYeAE, .browser-mode .program-sheet-skeleton__description-line--full__W4ln0 {
    margin-top: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.program-sheet-skeleton__description-line--full__W4ln0 {
  width: 100%;
}
.program-sheet-skeleton__description-line--wide__GYeAE {
  width: 92%;
}
.program-sheet-skeleton__description-line--short__QFeRn {
  width: 68%;
}

.program-sheet-background__EpHuF {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
}
.program-sheet-background__gradient__kvh57 {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(1, 18, 36, 0) 0%, rgba(1, 18, 36, 0.9) 60.26%, #011224 100%);
  z-index: 1;
}
.program-sheet-background__image__rvjXi {
  position: absolute;
  background-image: var(--image-src);
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 1;
  transition: all 0.15s ease;
}
.program-sheet-background__image--focused__XGKSt, .program-sheet-background__image__rvjXi:hover {
  filter: blur(20px);
}
.program-sheet-background__image--low-performance__rSo_t.program-sheet-background__image--focused__XGKSt, .program-sheet-background__image--low-performance__rSo_t:hover {
  filter: none;
  opacity: 0;
}
.program-sheet-background__image--using-portrait-cover__uJsq8:not(.program-sheet-background__image--focused__XGKSt) {
  filter: blur(10px);
}

.sheet-description-extended__zSyBm {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-left: 88px;
}
.browser-mode .sheet-description-extended__zSyBm {
  padding-left: calc(88px * 0.65);
}
.sheet-description-extended__zSyBm {
  padding-right: 88px;
}
.browser-mode .sheet-description-extended__zSyBm {
  padding-right: calc(88px * 0.65);
}
.sheet-description-extended__zSyBm {
  padding-top: 88px;
}
.browser-mode .sheet-description-extended__zSyBm {
  padding-top: calc(88px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-description-extended__zSyBm {
    padding-left: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .sheet-description-extended__zSyBm {
    padding-right: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .sheet-description-extended__zSyBm {
    padding-top: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
}
.sheet-description-extended__title__PxmxX {
  margin-top: 16px;
}
.browser-mode .sheet-description-extended__title__PxmxX {
  margin-top: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-description-extended__title__PxmxX {
    margin-top: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.sheet-description-extended__container__F6pW1 {
  display: flex;
  flex-grow: 1;
  margin-top: 40px;
}
.browser-mode .sheet-description-extended__container__F6pW1 {
  margin-top: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-description-extended__container__F6pW1 {
    margin-top: clamp(calc(calc(40px * 0.65) * 0.4583333333), calc(calc(40px * 0.65) * 0.4583333333) + (calc(40px * 0.65) - calc(calc(40px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-description-extended__back-button__swf44 {
  flex-shrink: 0;
  width: 256px;
}
.browser-mode .sheet-description-extended__back-button__swf44 {
  width: calc(256px * 0.65);
}
.sheet-description-extended__back-button__swf44 {
  margin-right: 190px;
}
.browser-mode .sheet-description-extended__back-button__swf44 {
  margin-right: calc(190px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-description-extended__back-button__swf44 {
    width: clamp(calc(calc(256px * 0.65) * 0.4583333333), calc(calc(256px * 0.65) * 0.4583333333) + (calc(256px * 0.65) - calc(calc(256px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(256px * 0.65));
  }
  .browser-mode .sheet-description-extended__back-button__swf44 {
    margin-right: clamp(calc(calc(190px * 0.65) * 0.4583333333), calc(calc(190px * 0.65) * 0.4583333333) + (calc(190px * 0.65) - calc(calc(190px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(190px * 0.65));
  }
}
.sheet-description-extended__content__BvDKZ {
  overflow-y: scroll;
  overflow-x: hidden;
  word-wrap: break-word;
}
.browser-mode .sheet-description-extended__content__BvDKZ {
  max-width: 1920px;
  height: auto;
}
.sheet-description-extended__content__BvDKZ {
  padding-bottom: 88px;
}
.browser-mode .sheet-description-extended__content__BvDKZ {
  padding-bottom: calc(88px * 0.65);
}
.sheet-description-extended__content__BvDKZ {
  height: 800px;
}
.browser-mode .sheet-description-extended__content__BvDKZ {
  height: calc(800px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-description-extended__content__BvDKZ {
    padding-bottom: clamp(calc(calc(88px * 0.65) * 0.4583333333), calc(calc(88px * 0.65) * 0.4583333333) + (calc(88px * 0.65) - calc(calc(88px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(88px * 0.65));
  }
  .browser-mode .sheet-description-extended__content__BvDKZ {
    height: clamp(calc(calc(800px * 0.65) * 0.4583333333), calc(calc(800px * 0.65) * 0.4583333333) + (calc(800px * 0.65) - calc(calc(800px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(800px * 0.65));
  }
}
.sheet-description-extended__content__BvDKZ::-webkit-scrollbar {
  width: 16px;
  margin-left: 183px;
}
.sheet-description-extended__content__BvDKZ::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 6px;
}
.sheet-description-extended__content--focused__RVGsA::-webkit-scrollbar-thumb {
  background: #f2f2f2;
}
.sheet-description-extended__description__Jcyte {
  margin-bottom: 40px;
}
.browser-mode .sheet-description-extended__description__Jcyte {
  margin-bottom: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-description-extended__description__Jcyte {
    margin-bottom: clamp(calc(calc(40px * 0.65) * 0.4583333333), calc(calc(40px * 0.65) * 0.4583333333) + (calc(40px * 0.65) - calc(calc(40px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-description-extended__crew__gXma0, .sheet-description-extended__providers__JQjpx {
  margin-bottom: 24px;
}

.sheet-string-icons__VD6Ww {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.browser-mode .sheet-string-icons__VD6Ww {
  margin-top: calc(8px * 0.65);
}
.sheet-string-icons__VD6Ww {
  height: 40px;
}
.browser-mode .sheet-string-icons__VD6Ww {
  height: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__VD6Ww {
    margin-top: clamp(calc(calc(8px * 0.65) * 0.4583333333), calc(calc(8px * 0.65) * 0.4583333333) + (calc(8px * 0.65) - calc(calc(8px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(8px * 0.65));
  }
  .browser-mode .sheet-string-icons__VD6Ww {
    height: clamp(calc(calc(40px * 0.65) * 0.4583333333), calc(calc(40px * 0.65) * 0.4583333333) + (calc(40px * 0.65) - calc(calc(40px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons__VD6Ww {
  margin-top: 8px;
}
.browser-mode .sheet-string-icons__VD6Ww {
  margin-top: calc(8px * 0.65);
}
.sheet-string-icons__VD6Ww {
  height: 40px;
}
.browser-mode .sheet-string-icons__VD6Ww {
  height: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__VD6Ww {
    margin-top: clamp(calc(calc(8px * 0.65) * 0.4583333333), calc(calc(8px * 0.65) * 0.4583333333) + (calc(8px * 0.65) - calc(calc(8px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(8px * 0.65));
  }
  .browser-mode .sheet-string-icons__VD6Ww {
    height: clamp(calc(calc(40px * 0.65) * 0.4583333333), calc(calc(40px * 0.65) * 0.4583333333) + (calc(40px * 0.65) - calc(calc(40px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons--player__UBkwx {
  margin-top: 24px;
}
.browser-mode .sheet-string-icons--player__UBkwx {
  margin-top: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons--player__UBkwx {
    margin-top: clamp(calc(calc(24px * 0.65) * 0.4583333333), calc(calc(24px * 0.65) * 0.4583333333) + (calc(24px * 0.65) - calc(calc(24px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.sheet-string-icons--player__UBkwx {
  margin-top: 24px;
}
.browser-mode .sheet-string-icons--player__UBkwx {
  margin-top: calc(24px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons--player__UBkwx {
    margin-top: clamp(calc(calc(24px * 0.65) * 0.4583333333), calc(calc(24px * 0.65) * 0.4583333333) + (calc(24px * 0.65) - calc(calc(24px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(24px * 0.65));
  }
}
.sheet-string-icons__subscription-tag__rn21J {
  margin-left: 8px;
  background-color: #00c9a2;
  color: #000;
  font-weight: 700;
  padding: 4px 16px;
  border-radius: 8px;
}
.sheet-string-icons__icon__eCEe8 {
  margin-right: 8px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 {
  margin-right: calc(8px * 0.65);
}
.sheet-string-icons__icon__eCEe8 {
  margin-left: 16px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 {
  margin-left: calc(16px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__icon__eCEe8 {
    margin-right: clamp(calc(calc(8px * 0.65) * 0.4583333333), calc(calc(8px * 0.65) * 0.4583333333) + (calc(8px * 0.65) - calc(calc(8px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(8px * 0.65));
  }
  .browser-mode .sheet-string-icons__icon__eCEe8 {
    margin-left: clamp(calc(calc(16px * 0.65) * 0.4583333333), calc(calc(16px * 0.65) * 0.4583333333) + (calc(16px * 0.65) - calc(calc(16px * 0.65) * 0.4583333333)) * (100vw - 880px) / 1040px, calc(16px * 0.65));
  }
}
.sheet-string-icons__icon__eCEe8 {
  width: 40px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 {
  width: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__icon__eCEe8 {
    width: clamp(calc(34px * 0.65), calc(34px * 0.65) + (calc(40px * 0.65) - calc(34px * 0.65)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons__icon__eCEe8 {
  height: 40px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 {
  height: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__icon__eCEe8 {
    height: clamp(calc(34px * 0.65), calc(34px * 0.65) + (calc(40px * 0.65) - calc(34px * 0.65)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons__icon__eCEe8 svg {
  width: 40px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 svg {
  width: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__icon__eCEe8 svg {
    width: clamp(calc(34px * 0.65), calc(34px * 0.65) + (calc(40px * 0.65) - calc(34px * 0.65)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons__icon__eCEe8 svg {
  height: 40px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 svg {
  height: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__icon__eCEe8 svg {
    height: clamp(calc(34px * 0.65), calc(34px * 0.65) + (calc(40px * 0.65) - calc(34px * 0.65)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons__icon__eCEe8 svg {
  width: 40px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 svg {
  width: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__icon__eCEe8 svg {
    width: clamp(calc(34px * 0.65), calc(34px * 0.65) + (calc(40px * 0.65) - calc(34px * 0.65)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons__icon__eCEe8 svg {
  height: 40px;
}
.browser-mode .sheet-string-icons__icon__eCEe8 svg {
  height: calc(40px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__icon__eCEe8 svg {
    height: clamp(calc(34px * 0.65), calc(34px * 0.65) + (calc(40px * 0.65) - calc(34px * 0.65)) * (100vw - 880px) / 1040px, calc(40px * 0.65));
  }
}
.sheet-string-icons__icon__eCEe8 svg path {
  fill: #f2f2f2;
}
.sheet-string-icons__label--player__zzrlE {
  font-weight: 400;
  line-height: 1.27em;
  font-size: 22px;
}
.browser-mode .sheet-string-icons__label--player__zzrlE {
  font-size: calc(22px * 0.65);
}
@media (max-width: 1919px) {
  .browser-mode .sheet-string-icons__label--player__zzrlE {
    font-size: clamp(calc(18.7px * 0.65), calc(18.7px * 0.65) + (calc(22px * 0.65) - calc(18.7px * 0.65)) * (100vw - 880px) / 1040px, calc(22px * 0.65));
  }
}

.sheet-providers__koiZt {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.sheet-providers__content__Gd_p_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sheet-providers__items__qXo8T {
  width: 688px;
  padding: 16px 24px;
  margin-top: 40px;
}
.sheet-providers__item__F2c1B {
  margin-bottom: 14px;
}
.sheet-providers__item-content__JLkli {
  display: flex;
  flex-direction: row;
  height: 80px;
  align-items: center;
}
.sheet-providers__item-image__DV3tT {
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.3);
  margin-right: 16px;
}
.sheet-providers__item-details__SQmtm {
  display: flex;
  flex-direction: column;
}
.sheet-providers__item-npvr-icon__vHaNj {
  width: 32px;
  height: 32px;
  margin-right: 4px;
  position: absolute;
  transform: translate(-4px, -8px);
}
.sheet-providers__item-npvr-text__rOMOi {
  padding-left: 36px;
  padding-top: 2px;
}

.sheet-spacer__YTILP {
  margin-left: 16px;
  margin-right: 16px;
  display: inline;
}`, "",{"version":3,"sources":["webpack://./src/scaffold/styles/variables.scss","webpack://./src/scaffold/styles/utilities.scss","webpack://./src/components/program-sheet/program-sheet.module.scss"],"names":[],"mappings":"AAOA,iCAAA;AAeA,eAAA;AAUA,0BAAA;AAqCA,eAAA;AAEA,0BAAA;AA+EA,0BAAA;AAMA,eAAA;AAEA,uBAAA;AA+EA,eAAA;AAEA,mBAAA;AAqBA,eAAA;AAEA,oBAAA;AAOA,eAAA;ACzPA;;;;;;;;CAAA;AAcA;;;;;CAAA;AAiCA;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAyBA;;;;;;;CAAA;AAyCA;;;;;;CAAA;AA8BA;;;;;;;;CAAA;AAwCA;;;;;;;;;;;;;;;;;CAAA;AAmDA;;;;;;;;;;;;;;;;;CAAA;AC3PA;EACE,sCAAA;EACA,kBAAA;AA8GF;AA5GE;EACE,6BAAA;AA8GJ;AA3GE;EDuQE,oBCrQE;AA4GN;AD2JI;EACE,iCAAA;ACzJN;ADpEE;EAoOI;IACE,kNAAA;EC7JN;AACF;AA9GE;EACE,aAAA;EACA,sBAAA;ED6PA,aC1PE;AA8GN;AD8II;EACE,0BAAA;AC5IN;AAtHE;ED+PE,oBC1PE;AAoHN;ADwII;EACE,iCAAA;ACtIN;AA5HE;ED+PE,kBC1PE;AA0HN;ADkII;EACE,+BAAA;AChIN;AAlIE;ED+PE,mBC1PE;AAgIN;AD4HI;EACE,gCAAA;AC1HN;ADnGE;EAoOI;IACE,+MAAA;EC9HN;ED6HI;IACE,kNAAA;EC3HN;ED0HI;IACE,gNAAA;ECxHN;EDuHI;IACE,iNAAA;ECrHN;AACF;AAzII;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;EACA,YAAA;AA2IN;AAxII;EACE,gBAAA;EACA,cAAA;EACA,4CAAA;EACA,sCAAA;ED+LJ,mBC7LmD;AAyIrD;ADuDE;EACE,gCARmB;AC7CvB;ADnIE;EAuLA;IAII,wJAAA;ECpDJ;AACF;AAvJI;EDmMF,mBC5LmD;AAmJrD;AD4CE;EACE,gCARmB;AClCvB;AD9IE;EAuLA;IAII,wJAAA;ECzCJ;AACF;AAlKI;EDmMF,kBC3LkD;AA6JpD;ADiCE;EACE,+BARmB;ACvBvB;ADzJE;EAuLA;IAII,uJAAA;EC9BJ;AACF;AA7KI;EDmMF,YC1L2C;AAuK7C;ADsBE;EACE,yBARmB;ACZvB;ADpKE;EAuLA;IAII,wJAAA;ECnBJ;AACF;AAxLI;EDmMF,aCzL4C;AAiL9C;ADWE;EACE,0BARmB;ACDvB;AD/KE;EAuLA;IAII,sJAAA;ECRJ;AACF;AAnMI;EAWE,mBAAA;EACA,mBAAA;AA2LN;AAxLI;EACE,4CAAA;AA0LN;AAtLE;EACE,aAAA;EACA,sBAAA;AAwLJ;AAtLI;EACE,aAAA;EDgNF,kBC7MI;AAsLR;ADyBI;EACE,+BAAA;ACvBN;AA7LI;EDiNA,mBC7MI;AA4LR;ADmBI;EACE,gCAAA;ACjBN;AD5ME;EAoOI;IACE,gNAAA;ECrBN;EDoBI;IACE,iNAAA;EClBN;AACF;AAjMI;EACE,gBF4Fa;EC0Gf,eCpMI;AAkMR;ADII;EACE,4BAAA;ACFN;AD3NE;EAoOI;IACE,6MAAA;ECNN;AACF;AA7MI;EAOE,cFgBkB;AEyLxB;AAtMI;EACE,aAAA;EACA,sBAAA;ED2LF,aCzLI;AAuMR;ADZI;EACE,0BAAA;ACcN;AA9MI;ED6LA,YCzLI;AA6MR;ADlBI;EACE,yBAAA;ACoBN;ADjPE;EAoOI;IACE,+MAAA;ECgBN;EDjBI;IACE,8MAAA;ECmBN;AACF;AAlNM;EACE,gBAAA;EACA,gBAAA;AAoNR;AAlNM;EACE,aAAA;EACA,mBAAA;AAoNR;AAjNM;EACE,kBAAA;EDyKJ,gBCvKM;AAkNV;ADzCI;EACE,6BAAA;AC2CN;ADxQE;EAoOI;IACE,8MAAA;ECuCN;AACF;AArNQ;EACE,WAAA;EDiKN,gBC/JQ;AAsNZ;ADrDI;EACE,6BAAA;ACuDN;ADpRE;EAoOI;IACE,8MAAA;ECmDN;AACF;AAvNU;EDwJN,YCtJU;AAwNd;ADhEI;EACE,yBAAA;ACkEN;AA7NU;EDwJN,WCtJU;AA8Nd;ADtEI;EACE,wBAAA;ACwEN;ADrSE;EAoOI;IACE,0MAAA;ECoEN;EDrEI;IACE,yMAAA;ECuEN;AACF;AAhOU;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EDyIR,gBCtIU;AAgOd;ADxFI;EACE,6BAAA;AC0FN;ADvTE;EAoOI;IACE,8MAAA;ECsFN;AACF;AAhOM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAkOR;AAhOQ;EACE,WAAA;EDwHN,kBCrHQ;AAgOZ;ADzGI;EACE,+BAAA;AC2GN;ADxUE;EAoOI;IACE,4MAAA;ECuGN;AACF;AAlOQ;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;ED2GN,iBCzGQ;AAmOZ;ADxHI;EACE,8BAAA;AC0HN;ADvVE;EAoOI;IACE,+MAAA;ECsHN;AACF;AAnOI;EDiGA,kBC/FI;AAoOR;ADnII;EACE,+BAAA;ACqIN;AAzOI;EDiGA,aC/FI;AA0OR;ADzII;EACE,0BAAA;AC2IN;ADxWE;EAoOI;IACE,oNAAA;ECuIN;EDxII;IACE,mNAAA;EC0IN;AACF;AA9OQ;EACE,eAAA;AAgPV;AAlPM;EAIE,0CAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,0BFhMU;ECgRd,kBC9EM;AAgPV;ADhKI;EACE,+BAAA;ACkKN;AA9PM;EDyFF,aC9EM;AAsPV;ADtKI;EACE,0BAAA;ACwKN;ADrYE;EAoOI;IACE,4MAAA;ECoKN;EDrKI;IACE,2MAAA;ECuKN;AACF;AA3PQ;EAEE,qBFhHI;EEiHJ,iBAAA;AA4PV;AAzPQ;EACE,aAAA;EACA,sBAAA;EDgEN,mBC9DQ;AA0PZ;AD1LI;EACE,gCAAA;AC4LN;ADzZE;EAoOI;IACE,iNAAA;ECwLN;AACF;AA5PQ;EDwDJ,kBCtDQ;AA6PZ;ADrMI;EACE,+BAAA;ACuMN;AAlQQ;EDwDJ,gBCtDQ;AAmQZ;AD3MI;EACE,6BAAA;AC6MN;AAxQQ;EDwDJ,gBCtDQ;AAyQZ;ADjNI;EACE,6BAAA;ACmNN;ADhbE;EAoOI;IACE,4MAAA;EC+MN;EDhNI;IACE,8MAAA;ECkNN;EDnNI;IACE,0MAAA;ECqNN;AACF;AA/QQ;EACE,4CAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;AAiRV;AA5QI;EACE,aAAA;EACA,8BAAA;AA8QN;;AAzQA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AA4QF;AA1QE;EACE,aAAA;EACA,qBAAA;EDiBA,aCdE;AA0QN;AD1PI;EACE,0BAAA;AC4PN;AAlRE;EDmBE,oBCdE;AAgRN;ADhQI;EACE,iCAAA;ACkQN;AAxRE;EDmBE,kBCdE;AAsRN;ADtQI;EACE,+BAAA;ACwQN;AA9RE;EDmBE,mBCdE;AA4RN;AD5QI;EACE,gCAAA;AC8QN;AD3eE;EAoOI;IACE,+MAAA;EC0QN;ED3QI;IACE,kNAAA;EC6QN;ED9QI;IACE,gNAAA;ECgRN;EDjRI;IACE,iNAAA;ECmRN;AACF;AApSE;EACE,UAAA;EACA,YAAA;AAsSJ;AAnSE;EACE,aAAA;EDDA,kBCIE;AAmSN;ADrSI;EACE,+BAAA;ACuSN;AA1SE;EDAE,mBCIE;AAySN;AD3SI;EACE,gCAAA;AC6SN;AD1gBE;EAoOI;IACE,gNAAA;ECySN;ED1SI;IACE,iNAAA;EC4SN;AACF;AA7SE;EACE,aAAA;EACA,sBAAA;EDbA,YCgBE;AA6SN;AD3TI;EACE,yBAAA;AC6TN;AD1hBE;EAoOI;IACE,8MAAA;ECyTN;AACF;AA/SE;EACE,UAAA;EACA,YAAA;AAiTJ;AA9SE;EACE,WAAA;EACA,YAAA;ED7BA,gBCgCE;AA8SN;AD5UI;EACE,6BAAA;AC8UN;AD3iBE;EAoOI;IACE,8MAAA;EC0UN;AACF;AAhTE;EACE,aAAA;EDvCA,gBC0CE;AAgTN;ADxVI;EACE,6BAAA;AC0VN;ADvjBE;EAoOI;IACE,8MAAA;ECsVN;AACF;AAlTE;EACE,WAAA;EACA,YAAA;AAoTJ;AAjTE;EDrDE,iBCuDE;AAkTN;ADvWI;EACE,8BAAA;ACyWN;ADtkBE;EAoOI;IACE,+MAAA;ECqWN;AACF;AApTE;EACE,aAAA;EACA,sBAAA;ED/DA,kBCkEE;AAoTN;ADpXI;EACE,+BAAA;ACsXN;AA5TE;ED7DE,aCkEE;AA0TN;AD1XI;EACE,0BAAA;AC4XN;AAlUE;ED7DE,aCkEE;AAgUN;ADhYI;EACE,0BAAA;ACkYN;AD/lBE;EAoOI;IACE,oNAAA;EC8XN;ED/XI;IACE,2MAAA;ECiYN;EDlYI;IACE,mNAAA;ECoYN;AACF;AAtUE;EACE,UAAA;EACA,YAAA;AAwUJ;AArUE;ED/EE,gBCiFE;AAsUN;ADrZI;EACE,6BAAA;ACuZN;ADpnBE;EAoOI;IACE,8MAAA;ECmZN;AACF;AAzUI;EAEE,WAAA;AA0UN;AAvUI;EAEE,UAAA;AAwUN;AArUI;EAEE,UAAA;AAsUN;;AAjUA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAoUF;AAlUE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qGAAA;EAMA,UAAA;AA+TJ;AA5TE;EACE,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,0BFlZc;AEgtBlB;AA5TI;EAEE,kBAAA;AA6TN;AA1TI;EAEE,YAAA;EACA,UAAA;AA2TN;AAvTM;EACE,kBAAA;AAyTR;;AAnTA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;ED1JE,kBC4JA;AAqTJ;AD/cI;EACE,+BAAA;ACidN;AA7TA;EDvJI,mBC4JA;AA2TJ;ADrdI;EACE,gCAAA;ACudN;AAnUA;EDvJI,iBC4JA;AAiUJ;AD3dI;EACE,8BAAA;AC6dN;AD1rBE;EAoOI;IACE,gNAAA;ECydN;ED1dI;IACE,iNAAA;EC4dN;ED7dI;IACE,+MAAA;EC+dN;AACF;AAxUE;EDnKE,gBCqKE;AAyUN;AD5eI;EACE,6BAAA;AC8eN;AD3sBE;EAoOI;IACE,8MAAA;EC0eN;AACF;AA3UE;EACE,aAAA;EACA,YAAA;ED7KA,gBC+KE;AA4UN;ADzfI;EACE,6BAAA;AC2fN;ADxtBE;EAoOI;IACE,8MAAA;ECufN;AACF;AA9UE;EACE,cAAA;EDtLA,YCwLE;AA+UN;ADrgBI;EACE,yBAAA;ACugBN;AArVE;EDrLE,mBCwLE;AAqVN;AD3gBI;EACE,gCAAA;AC6gBN;AD1uBE;EAoOI;IACE,8MAAA;ECygBN;ED1gBI;IACE,qNAAA;EC4gBN;AACF;AAzVE;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AA2VJ;AAzVI;EACE,iBF1cU;EE2cV,YAAA;AA2VN;AAlWE;ED/LE,oBCyME;AA2VN;ADliBI;EACE,iCAAA;ACoiBN;AAxWE;ED/LE,aCyME;AAiWN;ADxiBI;EACE,0BAAA;AC0iBN;ADvwBE;EAoOI;IACE,kNAAA;ECsiBN;EDviBI;IACE,+MAAA;ECyiBN;AACF;AAtWI;EACE,WAAA;EACA,kBAAA;AAwWN;AArWI;EACE,gBAAA;EACA,kBAAA;AAuWN;AApWM;EACE,mBFhZM;AEsvBd;AAjWE;ED/NE,mBCiOE;AAkWN;ADjkBI;EACE,gCAAA;ACmkBN;ADhyBE;EAoOI;IACE,iNAAA;EC+jBN;AACF;AApWE;EAEE,mBAAA;AAqWJ;;AAjWA;EACE,aAAA;EACA,mBAAA;ED/OE,eCkPA;AAkWJ;ADllBI;EACE,4BAAA;AColBN;AA1WA;ED7OI,YCkPA;AAwWJ;ADxlBI;EACE,yBAAA;AC0lBN;ADvzBE;EAoOI;IACE,yMAAA;ECslBN;EDvlBI;IACE,0MAAA;ECylBN;AACF;AAxXA;ED7OI,eCwPA;AAgXJ;ADtmBI;EACE,4BAAA;ACwmBN;AA9XA;ED7OI,YCwPA;AAsXJ;AD5mBI;EACE,yBAAA;AC8mBN;AD30BE;EAoOI;IACE,yMAAA;EC0mBN;ED3mBI;IACE,0MAAA;EC6mBN;AACF;AA3XE;ED9PE,gBCgQE;AA4XN;AD1nBI;EACE,6BAAA;AC4nBN;ADz1BE;EAoOI;IACE,8MAAA;ECwnBN;AACF;AAtYE;ED9PE,gBCqQE;AAkYN;ADroBI;EACE,6BAAA;ACuoBN;ADp2BE;EAoOI;IACE,8MAAA;ECmoBN;AACF;AArYE;EACE,gBAAA;EACA,yBFlbiB;EEmbjB,WFlcU;EEmcV,gBFxXe;EEyXf,iBAAA;EACA,kBAAA;AAuYJ;AApYE;EDnRE,iBCqRE;AAqYN;ADxpBI;EACE,8BAAA;AC0pBN;AA1YE;EDnRE,iBCqRE;AA2YN;AD9pBI;EACE,8BAAA;ACgqBN;AD73BE;EAoOI;IACE,2MAAA;EC4pBN;ED7pBI;IACE,+MAAA;EC+pBN;AACF;AAxZE;EDzTA,WDqBiB;AE+rBnB;ADjtBE;EACE,wBARmB;AC2tBvB;AD34BE;EAuLA;IAII,0IAAA;ECotBJ;AACF;AAnaE;EDzTA,YDqBiB;AE0sBnB;AD5tBE;EACE,yBARmB;ACsuBvB;ADt5BE;EAuLA;IAII,2IAAA;EC+tBJ;AACF;AAnaI;EDpUF,WDqBiB;AEqtBnB;ADvuBE;EACE,wBARmB;ACivBvB;ADj6BE;EAuLA;IAII,0IAAA;EC0uBJ;AACF;AA9aI;EDpUF,YDqBiB;AEguBnB;ADlvBE;EACE,yBARmB;AC4vBvB;AD56BE;EAuLA;IAII,2IAAA;ECqvBJ;AACF;AAzbI;EDpUF,WDqBiB;AE2uBnB;AD7vBE;EACE,wBARmB;ACuwBvB;ADv7BE;EAuLA;IAII,0IAAA;ECgwBJ;AACF;AApcI;EDpUF,YDqBiB;AEsvBnB;ADxwBE;EACE,yBARmB;ACkxBvB;ADl8BE;EAuLA;IAII,2IAAA;EC2wBJ;AACF;AAzcM;EACE,aF3dM;AEs6Bd;AArcI;EACE,gBAAA;EACA,mBFrViB;ECErB,eDJmB;AE+xBrB;ADxxBE;EACE,4BARmB;ACkyBvB;ADl9BE;EAuLA;IAII,oJAAA;EC2xBJ;AACF;;AArcA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAwcF;AAtcE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAwcJ;AArcE;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;AAucJ;AApcE;EACE,mBAAA;AAscJ;AAncE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAqcJ;AAlcE;EACE,+CAAA;EACA,kBAAA;AAocJ;AAjcE;EACE,aAAA;EACA,sBAAA;AAmcJ;AAhcE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAkcJ;AA/bE;EACE,kBAAA;EACA,gBAAA;AAicJ;;AA7bA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AAgcF","sourcesContent":["@use 'sass:math';\n\n$transition-base: all 0.15s ease;\n$network-log-width: 450px;\n$header-height: 150px;\n$page-padding: 88px;\n\n/* #region Responsive Framework */\n\n$breakpoint-sm: 880px;\n$breakpoint-ms: 1000px;\n$breakpoint-md: 1260px;\n$breakpoint-lg: 1320px;\n$breakpoint-xl: 1920px;\n$breakpoint-xxl: 1921px;\n// max for portrait collection\n$breakpoint-maxP: 2875px;\n// max for landscape collection\n$breakpoint-maxL: 3421px;\n\n$min-ratio-base: 0.65;\n\n/* #endregion */\n\n$dialog-max-width: $breakpoint-xl;\n$dialog-max-height: 1080px;\n$dialog-min-width: $breakpoint-sm;\n$dialog-sidebar-width: 695px;\n$dialog-sidebar-min-width: 250px;\n\n$player-sheet-width: 695px;\n\n/* #region Content Items */\n\n$media-item-min-ratio: 0.85;\n$media-item-max-ratio: 1.75;\n\n$portrait-width: 257px;\n$portrait-height: 367px;\n$portrait-ratio: math.div($portrait-height, $portrait-width) * 100%;\n$portrait-width-min: calc($portrait-width * $media-item-min-ratio);\n$portrait-width-max: calc($portrait-width * $media-item-max-ratio);\n\n$landscape-width: 406px;\n$landscape-height: 229px;\n$landscape-ratio: math.div($landscape-height, $landscape-width) * 100%;\n$landscape-width-min: calc($landscape-width * $media-item-min-ratio);\n$landscape-width-max: calc($landscape-width * $media-item-max-ratio);\n\n$wide-landscape-width: 554px;\n$wide-landscape-height: 214px;\n$wide-landscape-ratio: math.div($wide-landscape-height, $wide-landscape-width) * 100%;\n$wide-landscape-width-min: calc($wide-landscape-width * $media-item-min-ratio);\n$wide-landscape-width-max: calc($wide-landscape-width * $media-item-max-ratio);\n\n$provider-box-width: 257px;\n$provider-box-height: 168px;\n$provider-box-ratio: math.div($provider-box-height, $provider-box-width) * 100%;\n$provider-box-width-min: calc($provider-box-width * $media-item-min-ratio);\n$provider-box-width-max: calc($provider-box-width * $media-item-max-ratio);\n\n$content-item-logo-width: 50px;\n$content-item-logo-height: 32px;\n$content-item-logo-ratio: math.div($content-item-logo-height, $content-item-logo-width) * 100%;\n$content-item-logo-width-min: calc($content-item-logo-width * $media-item-min-ratio);\n$content-item-logo-width-max: calc($content-item-logo-width * $media-item-max-ratio);\n\n$back-icon-button-position: 12px;\n\n/* #endregion */\n\n/* #region Color Palette */\n\n// Shades\n$color-shades-secondary-20: #1f2b37;\n\n// Tints\n$color-tint-60: #011224;\n$color-tint-primary-10: #1a2a3a;\n$color-tint-primary-60: #99a0a7;\n$color-tint-secondary-10: #3d4a58;\n\n// Palette: Background\n$color-background-default: #252525;\n$color-background-primary: #011224;\n$color-background-secondary: #273645;\n$color-background-tertiary: #414d5b;\n$color-background-level1: #303030;\n$color-background-level2: #ccc;\n\n// Palette: Divider & Common\n$color-divider: #9e9e9e;\n$color-white: #f2f2f2;\n$color-black: #000;\n\n// Palette: Error\n$color-error-main: #f44336;\n$color-error-dark: #d32f2f;\n$color-error-secondary: #ffdb38;\n$color-error-contrast-text: #f2f2f2;\n\n// Palette: Grey\n$color-grey-light: #9b9b9b;\n$color-grey-main: #505050;\n$color-grey-dark: #303030;\n\n// Palette: Primary\n$color-primary-main: #369993;\n$color-primary-dark: #00c9a2;\n$color-primary-contrast-text: #000;\n\n// Palette: Secondary\n$color-secondary-main: #755ffa;\n$color-secondary-dark: #8370f1;\n$color-secondary-contrast-text: #000;\n\n// Palette: Tertiary\n$color-tertiary-main: rgba(65, 77, 91, 0.8);\n\n// Palette: Royal Blue\n$color-royalblue-main: #002b6b;\n$color-royalblue-dark: #3f82cf;\n\n// Palette: Light Purple\n$color-lightpurple-main: #e3e1ff;\n$color-lightpurple-dark: #e3e1ff;\n\n// Palette: Red\n$color-red-main: #f8232d;\n$color-red-dark: #f84049;\n\n// Palette: Success\n$color-success-main: #00c9a2;\n$color-success-light: #369993;\n\n// Palette: Text\n$color-text-primary: #f2f2f2;\n$color-text-primary-hover: #f2f2f2;\n$color-text-secondary: #9b9b9b;\n$color-text-secondary-hover: #f2f2f2;\n$color-text-dark: #011224;\n$color-text-tint-60: #93999f;\n\n// space indicators\n$color-space-indicator-recorded: #2ed28b;\n$color-space-indicator-scheduled: #3f82cf;\n$color-space-indicator-free: #f5f5ed;\n\n//#endregion\n\n/* #region Border Radius */\n\n$border-radius-sm: 4px;\n$border-radius-md: 8px;\n$border-radius-lg: 12px;\n\n/* #endregion */\n\n/* #region Typography */\n\n// Typography: Font Family\n$font-family: 'Norlys', sans-serif;\n$font-family-headline: 'Norlys Headline', sans-serif;\n\n// Typography: Weight\n$font-weight-light: 300;\n$font-weight-regular: 400;\n$font-weight-medium: 500;\n$font-weight-bold: 700;\n\n// min values are used for fluid typography, to ensure that the font size does not go below\n// a certain threshold on smaller screens. typically, the min value is set to half of the\n// max value, but it can be adjusted as needed.\n\n$typography-min-ratio: 0.85;\n\n// Typography: h1-h6, body, caption, button\n$h1-font-family: $font-family-headline;\n$h1-font-size: 88px;\n$h1-font-size-min: calc($h1-font-size * $typography-min-ratio);\n$h1-line-height: 1.36em; // was: 120px\n$h1-font-weight: $font-weight-bold;\n\n$h2-font-family: $font-family-headline;\n$h2-font-size: 72px;\n$h2-font-size-min: calc($h2-font-size * $typography-min-ratio);\n$h2-line-height: 1.36em; // was: 98px\n$h2-font-weight: $font-weight-bold;\n\n$h3-font-family: $font-family-headline;\n$h3-font-size: 60px;\n$h3-font-size-min: calc($h3-font-size * $typography-min-ratio);\n$h3-line-height: 1.4em; // was: 84px\n$h3-font-weight: $font-weight-regular;\n\n$h4-font-family: $font-family;\n$h4-font-size: 50px;\n$h4-font-size-min: calc($h4-font-size * $typography-min-ratio);\n$h4-line-height: 1.4em; // was: 70px\n$h4-font-weight: $font-weight-bold;\n\n$h5-font-family: $font-family;\n$h5-font-size: 42px;\n$h5-font-size-min: calc($h5-font-size * $typography-min-ratio);\n$h5-line-height: 1.33em; // was: 56px\n$h5-font-weight: $font-weight-regular;\n\n$h6-font-family: $font-family;\n$h6-font-size: 35px;\n$h6-font-size-min: calc($h6-font-size * $typography-min-ratio);\n$h6-line-height: 1.4em; // was: 49px\n$h6-font-weight: $font-weight-bold;\n\n$body-font-family: $font-family;\n$body-font-size: 32px;\n$body-font-size-min: calc($body-font-size * $typography-min-ratio);\n$body-line-height: 1.38em; // was: 44px\n$body-font-weight: $font-weight-regular;\n\n$body-small-font-family: $font-family;\n$body-small-font-size: 28px;\n$body-small-font-size-min: calc($body-small-font-size * $typography-min-ratio);\n$body-small-line-height: 1.39em; // was: 39px\n$body-small-font-weight: $font-weight-regular;\n\n$caption-font-family: $font-family;\n$caption-font-size: 24px;\n$caption-font-size-min: calc($caption-font-size * $typography-min-ratio);\n$caption-line-height: 1.46em; // was: 35px\n$caption-font-weight: $font-weight-bold;\n\n$caption2-font-family: $font-family;\n$caption2-font-size: 22px;\n$caption2-font-size-min: calc($caption2-font-size * $typography-min-ratio);\n$caption2-line-height: 1.27em; // was: 28px\n$caption2-font-weight: $font-weight-regular;\n\n/* #endregion */\n\n/* #region Button */\n$button-font-size: 24px;\n$button-font-size-min: calc($button-font-size * $typography-min-ratio);\n$button-height: 72px;\n$button-height-min: calc($button-height * $min-ratio-base);\n$button-width: 406px;\n$button-width-min: calc($button-width * $min-ratio-base);\n\n$button-sm-font-size: 22px;\n$button-sm-font-size-min: calc($button-sm-font-size * $typography-min-ratio);\n$button-sm-height: 56px;\n$button-sm-height-min: calc($button-sm-height * $min-ratio-base);\n\n$button-header-font-size: 32px;\n$button-header-font-size-min: calc($button-header-font-size * $typography-min-ratio);\n$button-header-height: 80px;\n$button-header-height-min: calc($button-header-height * $min-ratio-base);\n\n$button-icon-size: 40px;\n$button-icon-size-min: calc($button-icon-size * $typography-min-ratio);\n\n/* #endregion */\n\n/* #region Z-Index */\n\n$zindex-player-controls: 1250;\n$zindex-dialog: 1300;\n$zindex-overlay: 1400;\n$zindex-tooltip: 1500;\n\n/* #endregion */\n","@use 'sass:map';\n@use 'sass:math';\n@use 'sass:meta';\n@use '/src/scaffold/styles/variables' as vars;\n\n$spacing-step: 4px;\n\n$browser-scale-constant: 0.65;\n\n$breakpoints: (\n  sm: vars.$breakpoint-sm,\n  ms: vars.$breakpoint-ms,\n  md: vars.$breakpoint-md,\n  lg: vars.$breakpoint-lg,\n  xl: vars.$breakpoint-xl,\n  xxl: vars.$breakpoint-xxl,\n  maxP: vars.$breakpoint-maxP,\n  maxL: vars.$breakpoint-maxL\n);\n\n/*\n  The spacing function is a simple utility that takes a multiplier and returns the corresponding \n  spacing value based on the defined spacing step. This allows for easy adjustments to the overall \n  spacing of the app by simply changing the value of $spacing-step.\n\n  This is made only to mirror the spacing function in the design system.\n\n  - MRA\n*/\n\n@function spacing($multiplier) {\n  @return $spacing-step * $multiplier;\n}\n\n/*\n  The breakpoint mixins are utilities for handling responsive design. They allow you to write media queries \n  in a more readable and maintainable way by using named breakpoints defined in the $breakpoints map.\n\n  - MRA\n*/\n\n@function breakpoint($name) {\n  @if map.has-key($breakpoints, $name) {\n    @return map.get($breakpoints, $name);\n  }\n\n  @error 'Unknown breakpoint `#{$name}`. Available: #{map.keys($breakpoints)}';\n}\n\n@mixin respond-up($name) {\n  @media (min-width: breakpoint($name)) {\n    @content;\n  }\n}\n\n@mixin respond-down($name) {\n  @media (max-width: #{breakpoint($name) - 1px}) {\n    @content;\n  }\n}\n\n@mixin respond-between($min-name, $max-name) {\n  @media (min-width: breakpoint($min-name)) and (max-width: #{breakpoint($max-name) - 1px}) {\n    @content;\n  }\n}\n\n/*\n  Experimental\n\n  There are now two distinct fluid helpers in this file:\n\n  1. `fluid-props($map, $breakpoint)`\n     Keeps the existing behavior for a group of properties.\n     Static values are emitted first, and inside `respond-down($breakpoint)`\n     each property scales from the provided value down toward the `sm`\n     breakpoint using the original proportional logic.\n\n  2. `fluid-prop-range(...)`\n     Handles a single property with three explicit values:\n     - a base value, emitted outside any media query\n     - a min value, used for scaling down from `xl` to `sm`\n     - a max value, used for scaling up from `xxl` and above\n\n     The downscale path is a direct interpolation between the explicit\n     min and base values. The upscale path reuses the same proportional\n     viewport logic as the original helper, anchored to the base value,\n     and clamps the result so it never exceeds the explicit max value.\n\n  - MRA\n*/\n\n/*\n  Builds a clamp() expression from two explicit values and two explicit\n  breakpoints.\n\n  This is the low-level interpolation helper used when both endpoints are\n  known, for example when a property should be exactly 24px at `sm` and\n  exactly 40px at `xl`.\n*/\n\n@function fluid-between($min-value, $max-value, $min-breakpoint, $max-breakpoint) {\n  @if meta.type-of($min-value) != 'number' or meta.type-of($max-value) != 'number' {\n    $breakpoint-range: $max-breakpoint - $min-breakpoint;\n\n    @if $breakpoint-range <= 0px {\n      @error 'fluid-between requires max breakpoint to be larger than min breakpoint.';\n    }\n\n    @return clamp(\n      #{$min-value},\n      calc(#{$min-value} + (#{$max-value} - #{$min-value}) * ((100vw - #{$min-breakpoint}) / #{$breakpoint-range})),\n      #{$max-value}\n    );\n  }\n\n  $min-val-num: math.div($min-value, 1px);\n  $max-val-num: math.div($max-value, 1px);\n  $min-break-num: math.div($min-breakpoint, 1px);\n  $max-break-num: math.div($max-breakpoint, 1px);\n\n  @if $min-break-num >= $max-break-num {\n    @error 'fluid-between requires min breakpoint to be smaller than max breakpoint.';\n  }\n\n  $slope: math.div($max-val-num - $min-val-num, $max-break-num - $min-break-num);\n  $intercept: $min-val-num - ($slope * $min-break-num);\n  $clamp-min: math.min($min-val-num, $max-val-num);\n  $clamp-max: math.max($min-val-num, $max-val-num);\n\n  @return clamp(#{$clamp-min}px, calc(#{$intercept}px + #{$slope * 100}vw), #{$clamp-max}px);\n}\n\n/*\n  Recreates the original proportional scaling logic used by `fluid-prop`.\n\n  Only the upper value is supplied. The lower value is derived from the\n  ratio between the provided maximum value and its controlling breakpoint,\n  then passed through `fluid-between()` for the final clamp() expression.\n*/\n\n@function fluid-value($max-value, $min-breakpoint, $max-breakpoint) {\n  @if meta.type-of($max-value) != 'number' {\n    $ratio: math.div($min-breakpoint, $max-breakpoint);\n    $min-value: calc(#{$max-value} * #{$ratio});\n\n    @return fluid-between($min-value, $max-value, $min-breakpoint, $max-breakpoint);\n  }\n\n  $max-val-num: math.div($max-value, 1px);\n  $min-break-num: math.div($min-breakpoint, 1px);\n  $max-break-num: math.div($max-breakpoint, 1px);\n\n  @if $min-break-num >= $max-break-num {\n    @error 'fluid-value requires min breakpoint to be smaller than max breakpoint.';\n  }\n\n  $ratio: math.div($max-val-num, $max-break-num);\n  $min-value: $min-break-num * $ratio;\n\n  @return fluid-between($min-value * 1px, $max-value, $min-breakpoint, $max-breakpoint);\n}\n\n/*\n  Scales upward from a base value using the same proportional viewport logic\n  as the original helper, then clamps that growth to an explicit max value.\n\n  The ratio is anchored to the base value and its reference breakpoint.\n  In practice this means the property keeps its base value until the viewport\n  is large enough for the preferred fluid expression to exceed it, after which\n  it grows smoothly until the explicit max value is reached.\n*/\n\n@function fluid-max-value($base-value, $max-value, $base-breakpoint) {\n  @if meta.type-of($base-value) != 'number' or meta.type-of($max-value) != 'number' {\n    @return clamp(\n      #{$base-value},\n      calc((#{$base-value} / #{$base-breakpoint}) * 100vw),\n      #{$max-value}\n    );\n  }\n\n  $base-val-num: math.div($base-value, 1px);\n  $max-val-num: math.div($max-value, 1px);\n  $base-break-num: math.div($base-breakpoint, 1px);\n\n  @if $base-break-num <= 0 {\n    @error 'fluid-max-value requires a breakpoint larger than 0.';\n  }\n\n  @if $base-val-num > $max-val-num {\n    @error 'fluid-max-value requires max value to be greater than or equal to base value.';\n  }\n\n  $ratio: math.div($base-val-num, $base-break-num);\n\n  @return clamp(#{$base-val-num}px, calc(#{$ratio * 100}vw), #{$max-val-num}px);\n}\n\n@function fluid-prop($max-value, $min-name: sm, $max-name: xl) {\n  @return fluid-value($max-value, breakpoint($min-name), breakpoint($max-name));\n}\n\n/*\n  Single-property helper for the three-value case.\n\n  Output behavior:\n  - Base value is emitted directly, outside any media query.\n  - Inside `respond-down($base-name)`, the property scales from the explicit\n    min value up to the base value.\n  - If `$max-value` is provided, inside `respond-up($max-name)` the property\n    scales upward from the base value and is clamped so it never exceeds the\n    explicit max value.\n  - If `$max-value` is omitted (or `null`), no upscale media query is emitted.\n\n  Example:\n  @include utils.fluid-prop-range(font-size, 40px, 24px, 56px);\n\n  Example without max:\n  @include utils.fluid-prop-range(font-size, 40px, 24px);\n*/\n\n@mixin fluid-prop-range(\n  $prop,\n  $base-value,\n  $min-value,\n  $max-value: null,\n  $min-name: sm,\n  $base-name: xl,\n  $max-name: xxl\n) {\n\n  $browser-base-value: calc(#{ $base-value} * $browser-scale-constant);\n  $browser-min-value: calc(#{ $min-value} * $browser-scale-constant);\n  $browser-max-value: calc(#{ $max-value} * $browser-scale-constant);\n\n  #{$prop}: $base-value;\n\n  // Responsive functionality is now isolated to browser-mode\n  :global(.browser-mode) & {\n    #{$prop}: $browser-base-value;\n  \n    @include respond-down($base-name) {\n      #{$prop}: fluid-between($browser-min-value, $browser-base-value, breakpoint($min-name), breakpoint($base-name));\n    }\n\n    @if $max-value != null {\n      @include respond-up($max-name) {\n        #{$prop}: fluid-max-value($browser-base-value, $browser-max-value, breakpoint($base-name));\n      }\n    }\n  }\n}\n\n/*\n  Group-property helper for the original xl-to-sm scaling case.\n\n  Output behavior:\n  - Each property in the map is emitted first as a static base value,\n    outside any media query.\n  - Inside `respond-down($breakpoint)`, every property in the map is\n    recalculated with the original proportional fluid logic so it scales\n    down toward the `sm` breakpoint.\n\n  This helper is intended for the existing multi-property scenario where a\n  component has one shared upper breakpoint and each property should shrink\n  proportionally beneath it.\n\n  Examples:\n  @include utils.fluid-props((margin-top: 64px, margin-left: 52px));\n  @include utils.fluid-props((margin-top: 64px), $breakpoint: lg);\n*/\n@mixin fluid-props($map, $breakpoint: xl) {\n  @each $prop, $val in $map {\n    #{$prop}: $val;\n\n    :global(.browser-mode) & {\n      #{$prop}: calc(#{ $val} * $browser-scale-constant);\n    }\n  }\n\n\n  @include respond-down($breakpoint) {\n    @each $prop, $val in $map {\n      :global(.browser-mode) & {\n        #{$prop}: fluid-prop(calc(#{ $val} * $browser-scale-constant), sm, $breakpoint);\n      }\n    }\n  }\n}\n\n// END experimental\n","@use '/src/scaffold/styles/variables' as vars;\n@use '/src/scaffold/styles/utilities' as utils;\n\n.program-sheet {\n  transition: transform 0.3s ease-in-out;\n  position: relative;\n\n  &--focused {\n    transform: translateY(-925px);\n  }\n\n  &--scrollable {\n    @include utils.fluid-props(\n      (\n        padding-bottom: vars.$page-padding\n      )\n    );\n  }\n\n  .program-sheet-header {\n    display: flex;\n    flex-direction: column;\n\n    @include utils.fluid-props(\n      (\n        height: 580px,\n        padding-bottom: 16px,\n        padding-left: vars.$page-padding,\n        padding-right: vars.$page-padding\n      )\n    );\n\n    &__title {\n      margin-top: auto;\n      display: flex;\n      flex-direction: row;\n      align-items: flex-end;\n      justify-content: flex-start;\n      min-width: 0;\n    }\n\n    &__title-image {\n      margin-top: auto;\n      flex-shrink: 0;\n      border: 2.5px solid rgba(242, 242, 242, 0.2);\n      box-shadow: 0px 10px 16px rgba(0, 0, 0, 1);\n\n      @include utils.fluid-prop-range(border-radius, 16px, calc(16px * vars.$min-ratio-base));\n      @include utils.fluid-prop-range(margin-bottom, 24px, calc(24px * vars.$min-ratio-base));\n      @include utils.fluid-prop-range(margin-right, 24px, calc(24px * vars.$min-ratio-base));\n      @include utils.fluid-prop-range(width, 157px, calc(157px * vars.$min-ratio-base));\n      @include utils.fluid-prop-range(height, 234px, calc(234px * vars.$min-ratio-base));\n      min-width: calc(157px * vars.$min-ratio-base);\n      min-height: calc(234px * vars.$min-ratio-base);\n    }\n\n    &__title-text {\n      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    }\n  }\n\n  .program-sheet-content {\n    display: flex;\n    flex-direction: column;\n\n    &__container {\n      display: flex;\n\n      @include utils.fluid-props(\n        (\n          padding-left: vars.$page-padding,\n          padding-right: vars.$page-padding\n        )\n      );\n    }\n    &__missing-access {\n      font-weight: vars.$font-weight-bold;\n      @include utils.fluid-props(\n        (\n          font-size: vars.$caption-font-size\n        )\n      );\n      color: vars.$color-error-secondary;\n    }\n\n    &__left-column {\n      display: flex;\n      flex-direction: column;\n      @include utils.fluid-props(\n        (\n          height: 335px,\n          width: 560px\n        )\n      );\n\n      .sheet-meta__tv {\n        margin-top: -8px;\n        overflow: hidden;\n      }\n      .sheet-meta__browser {\n        display: flex;\n        align-items: center;\n      }\n\n      .sheet-buttons {\n        position: relative;\n        @include utils.fluid-props(\n          (\n            margin-top: 16px\n          )\n        );\n\n        &__button {\n          width: 100%;\n          @include utils.fluid-props(\n            (\n              margin-top: 24px\n            )\n          );\n        }\n\n        :global(.browser-mode &) {\n          :global(.icon-button) {\n            @include utils.fluid-props(\n              (\n                height: 72px,\n                width: 72px\n              )\n            );\n          }\n        }\n\n        &__secondary {\n          &--flex {\n            display: flex;\n            flex-direction: row;\n            justify-content: flex-start;\n            align-items: center;\n\n            @include utils.fluid-props(\n              (\n                margin-top: 40px\n              )\n            );\n          }\n        }\n      }\n\n      .progress {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        &__bar {\n          width: 100%;\n\n          @include utils.fluid-props(\n            (\n              border-radius: 4px\n            )\n          );\n        }\n\n        &__duration {\n          display: flex;\n          flex-direction: row;\n          box-sizing: border-box;\n          white-space: nowrap;\n          @include utils.fluid-props(\n            (\n              margin-left: 32px\n            )\n          );\n        }\n      }\n    }\n\n    &__right-column {\n      @include utils.fluid-props(\n        (\n          margin-left: 184px,\n          width: 1000px\n        )\n      );\n\n      .description {\n        &:hover {\n          cursor: pointer;\n        }\n        border: 4px solid rgba(vars.$color-white, 0.2);\n        box-sizing: border-box;\n        height: auto;\n        align-self: flex-start;\n        width: 100%;\n        transition: vars.$transition-base;\n        @include utils.fluid-props(\n          (\n            border-radius: 8px,\n            padding: 16px\n          )\n        );\n\n        &--focused,\n        &:hover {\n          border-color: vars.$color-white;\n          border-width: 4px;\n        }\n\n        &__info {\n          display: flex;\n          flex-direction: column;\n          @include utils.fluid-props(\n            (\n              margin-bottom: 20px\n            )\n          );\n        }\n\n        &__headline {\n          @include utils.fluid-props(\n            (\n              margin-bottom: 4px,\n              margin-top: 16px,\n              font-weight: 700\n            )\n          );\n        }\n\n        &__body {\n          text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n          overflow: hidden;\n          text-overflow: ellipsis;\n          display: -webkit-box;\n          -webkit-line-clamp: 3;\n          line-clamp: 3;\n          -webkit-box-orient: vertical;\n        }\n      }\n    }\n\n    &__bottom-column {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n}\n\n.program-sheet-skeleton {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n\n  &__header {\n    display: flex;\n    align-items: flex-end;\n\n    @include utils.fluid-props(\n      (\n        height: 580px,\n        padding-bottom: 40px,\n        padding-left: vars.$page-padding,\n        padding-right: vars.$page-padding\n      )\n    );\n  }\n\n  &__header-skeleton {\n    width: 42%;\n    height: 64px;\n  }\n\n  &__content {\n    display: flex;\n\n    @include utils.fluid-props(\n      (\n        padding-left: vars.$page-padding,\n        padding-right: vars.$page-padding\n      )\n    );\n  }\n\n  &__actions {\n    display: flex;\n    flex-direction: column;\n\n    @include utils.fluid-props(\n      (\n        width: 560px\n      )\n    );\n  }\n\n  &__action-label {\n    width: 45%;\n    height: 28px;\n  }\n\n  &__action-button {\n    width: 100%;\n    height: 72px;\n\n    @include utils.fluid-props(\n      (\n        margin-top: 24px\n      )\n    );\n  }\n\n  &__secondary-actions {\n    display: flex;\n\n    @include utils.fluid-props(\n      (\n        margin-top: 24px\n      )\n    );\n  }\n\n  &__secondary-action {\n    width: 72px;\n    height: 72px;\n  }\n\n  &__secondary-action + &__secondary-action {\n    @include utils.fluid-props(\n      (\n        margin-left: 24px\n      )\n    );\n  }\n\n  &__description {\n    display: flex;\n    flex-direction: column;\n\n    @include utils.fluid-props(\n      (\n        margin-left: 184px,\n        padding: 20px,\n        width: 1000px\n      )\n    );\n  }\n\n  &__description-heading {\n    width: 32%;\n    height: 32px;\n  }\n\n  &__description-line {\n    @include utils.fluid-props(\n      (\n        margin-top: 16px\n      )\n    );\n\n    &--full {\n      @extend .program-sheet-skeleton__description-line;\n      width: 100%;\n    }\n\n    &--wide {\n      @extend .program-sheet-skeleton__description-line;\n      width: 92%;\n    }\n\n    &--short {\n      @extend .program-sheet-skeleton__description-line;\n      width: 68%;\n    }\n  }\n}\n\n.program-sheet-background {\n  position: absolute;\n  z-index: 0;\n  width: 100%;\n  height: 100%;\n\n  &__gradient {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      180deg,\n      rgba(vars.$color-background-primary, 0) 0%,\n      rgba(vars.$color-background-primary, 0.9) 60.26%,\n      vars.$color-background-primary 100%\n    );\n    z-index: 1;\n  }\n\n  &__image {\n    position: absolute;\n    background-image: var(--image-src);\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    opacity: 1;\n    transition: vars.$transition-base;\n\n    &--focused,\n    &:hover {\n      filter: blur(20px);\n    }\n\n    &--low-performance.program-sheet-background__image--focused,\n    &--low-performance:hover {\n      filter: none;\n      opacity: 0;\n    }\n\n    &--using-portrait-cover {\n      &:not(.program-sheet-background__image--focused) {\n        filter: blur(10px);\n      }\n    }\n  }\n}\n\n.sheet-description-extended {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  @include utils.fluid-props(\n    (\n      padding-left: vars.$page-padding,\n      padding-right: vars.$page-padding,\n      padding-top: vars.$page-padding\n    )\n  );\n\n  &__title {\n    @include utils.fluid-props(\n      (\n        margin-top: 16px\n      )\n    );\n  }\n\n  &__container {\n    display: flex;\n    flex-grow: 1;\n    @include utils.fluid-props(\n      (\n        margin-top: 40px\n      )\n    );\n  }\n\n  &__back-button {\n    flex-shrink: 0;\n    @include utils.fluid-props(\n      (\n        width: 256px,\n        margin-right: 190px\n      )\n    );\n  }\n\n  &__content {\n    overflow-y: scroll;\n    overflow-x: hidden;\n    word-wrap: break-word;\n\n    :global(.browser-mode) & {\n      max-width: vars.$breakpoint-xl;\n      height: auto;\n    }\n    @include utils.fluid-props(\n      (\n        padding-bottom: vars.$page-padding,\n        height: 800px\n      )\n    );\n\n    &::-webkit-scrollbar {\n      width: 16px;\n      margin-left: 183px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: grey;\n      border-radius: 6px;\n    }\n    &--focused {\n      &::-webkit-scrollbar-thumb {\n        background: vars.$color-white;\n      }\n    }\n  }\n\n  &__description {\n    @include utils.fluid-props(\n      (\n        margin-bottom: 40px\n      )\n    );\n  }\n\n  &__crew,\n  &__providers {\n    margin-bottom: 24px;\n  }\n}\n\n.sheet-string-icons {\n  display: flex;\n  align-items: center;\n\n  @include utils.fluid-props(\n    (\n      margin-top: 8px,\n      height: 40px\n    )\n  );\n  @include utils.fluid-props(\n    (\n      margin-top: 8px,\n      height: 40px\n    )\n  );\n\n  &--player {\n    @include utils.fluid-props(\n      (\n        margin-top: 24px\n      )\n    );\n    @include utils.fluid-props(\n      (\n        margin-top: 24px\n      )\n    );\n  }\n  &__subscription-tag {\n    margin-left: 8px;\n    background-color: vars.$color-primary-dark;\n    color: vars.$color-black;\n    font-weight: vars.$font-weight-bold;\n    padding: 4px 16px;\n    border-radius: 8px;\n  }\n\n  &__icon {\n    @include utils.fluid-props(\n      (\n        margin-right: 8px,\n        margin-left: 16px\n      )\n    );\n\n    @include utils.fluid-prop-range(width, vars.$button-icon-size, vars.$button-icon-size-min);\n    @include utils.fluid-prop-range(height, vars.$button-icon-size, vars.$button-icon-size-min);\n\n    svg {\n      @include utils.fluid-prop-range(width, vars.$button-icon-size, vars.$button-icon-size-min);\n      @include utils.fluid-prop-range(height, vars.$button-icon-size, vars.$button-icon-size-min);\n      @include utils.fluid-prop-range(width, vars.$button-icon-size, vars.$button-icon-size-min);\n      @include utils.fluid-prop-range(height, vars.$button-icon-size, vars.$button-icon-size-min);\n\n      path {\n        fill: vars.$color-white;\n      }\n    }\n  }\n\n  &__label {\n    &--player {\n      font-weight: 400;\n      line-height: vars.$caption2-line-height;\n\n      @include utils.fluid-prop-range(\n        font-size,\n        vars.$caption2-font-size,\n        vars.$caption2-font-size-min\n      );\n    }\n  }\n}\n\n.sheet-providers {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__items {\n    width: 688px;\n    padding: 16px 24px;\n    margin-top: 40px;\n  }\n\n  &__item {\n    margin-bottom: 14px;\n  }\n\n  &__item-content {\n    display: flex;\n    flex-direction: row;\n    height: 80px;\n    align-items: center;\n  }\n\n  &__item-image {\n    box-shadow: 0px 4px 16px 0px rgba(vars.$color-black, 0.3);\n    margin-right: 16px;\n  }\n\n  &__item-details {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__item-npvr-icon {\n    width: 32px;\n    height: 32px;\n    margin-right: 4px;\n    position: absolute;\n    transform: translate(-4px, -8px);\n  }\n\n  &__item-npvr-text {\n    padding-left: 36px;\n    padding-top: 2px;\n  }\n}\n\n.sheet-spacer {\n  margin-left: 16px;\n  margin-right: 16px;\n  display: inline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"program-sheet": `program-sheet__JgVWS`,
	"program-sheet--focused": `program-sheet--focused__PFKKX`,
	"program-sheet--scrollable": `program-sheet--scrollable__VV8jo`,
	"program-sheet-header": `program-sheet-header__QJlcD`,
	"program-sheet-header__title": `program-sheet-header__title__I7qig`,
	"program-sheet-header__title-image": `program-sheet-header__title-image__deSus`,
	"program-sheet-header__title-text": `program-sheet-header__title-text__ll37V`,
	"program-sheet-content": `program-sheet-content___C5D8`,
	"program-sheet-content__container": `program-sheet-content__container__Fk9C_`,
	"program-sheet-content__missing-access": `program-sheet-content__missing-access__aeQ33`,
	"program-sheet-content__left-column": `program-sheet-content__left-column__W2sxQ`,
	"sheet-meta__tv": `sheet-meta__tv__Qw_dJ`,
	"sheet-meta__browser": `sheet-meta__browser__E1sZg`,
	"sheet-buttons": `sheet-buttons__gJQfj`,
	"sheet-buttons__button": `sheet-buttons__button__et8Rp`,
	"sheet-buttons__secondary--flex": `sheet-buttons__secondary--flex__sREBQ`,
	"progress": `progress__cuGPF`,
	"progress__bar": `progress__bar__RSwLh`,
	"progress__duration": `progress__duration__n9tvI`,
	"program-sheet-content__right-column": `program-sheet-content__right-column__O45un`,
	"description": `description__Rts4M`,
	"description--focused": `description--focused__aQP_7`,
	"description__info": `description__info__xbj0P`,
	"description__headline": `description__headline__YzZHZ`,
	"description__body": `description__body__Chupx`,
	"program-sheet-content__bottom-column": `program-sheet-content__bottom-column__M_ksy`,
	"program-sheet-skeleton": `program-sheet-skeleton__QM_dm`,
	"program-sheet-skeleton__header": `program-sheet-skeleton__header__kMEeT`,
	"program-sheet-skeleton__header-skeleton": `program-sheet-skeleton__header-skeleton__yRr6Z`,
	"program-sheet-skeleton__content": `program-sheet-skeleton__content__KKMLl`,
	"program-sheet-skeleton__actions": `program-sheet-skeleton__actions__C11wZ`,
	"program-sheet-skeleton__action-label": `program-sheet-skeleton__action-label__hM4fG`,
	"program-sheet-skeleton__action-button": `program-sheet-skeleton__action-button__Lq3AJ`,
	"program-sheet-skeleton__secondary-actions": `program-sheet-skeleton__secondary-actions__D6Jc6`,
	"program-sheet-skeleton__secondary-action": `program-sheet-skeleton__secondary-action__l716P`,
	"program-sheet-skeleton__description": `program-sheet-skeleton__description__wqZak`,
	"program-sheet-skeleton__description-heading": `program-sheet-skeleton__description-heading__bOdyT`,
	"program-sheet-skeleton__description-line": `program-sheet-skeleton__description-line__CtR6R`,
	"program-sheet-skeleton__description-line--short": `program-sheet-skeleton__description-line--short__QFeRn`,
	"program-sheet-skeleton__description-line--wide": `program-sheet-skeleton__description-line--wide__GYeAE`,
	"program-sheet-skeleton__description-line--full": `program-sheet-skeleton__description-line--full__W4ln0`,
	"program-sheet-background": `program-sheet-background__EpHuF`,
	"program-sheet-background__gradient": `program-sheet-background__gradient__kvh57`,
	"program-sheet-background__image": `program-sheet-background__image__rvjXi`,
	"program-sheet-background__image--focused": `program-sheet-background__image--focused__XGKSt`,
	"program-sheet-background__image--low-performance": `program-sheet-background__image--low-performance__rSo_t`,
	"program-sheet-background__image--using-portrait-cover": `program-sheet-background__image--using-portrait-cover__uJsq8`,
	"sheet-description-extended": `sheet-description-extended__zSyBm`,
	"sheet-description-extended__title": `sheet-description-extended__title__PxmxX`,
	"sheet-description-extended__container": `sheet-description-extended__container__F6pW1`,
	"sheet-description-extended__back-button": `sheet-description-extended__back-button__swf44`,
	"sheet-description-extended__content": `sheet-description-extended__content__BvDKZ`,
	"sheet-description-extended__content--focused": `sheet-description-extended__content--focused__RVGsA`,
	"sheet-description-extended__description": `sheet-description-extended__description__Jcyte`,
	"sheet-description-extended__crew": `sheet-description-extended__crew__gXma0`,
	"sheet-description-extended__providers": `sheet-description-extended__providers__JQjpx`,
	"sheet-string-icons": `sheet-string-icons__VD6Ww`,
	"sheet-string-icons--player": `sheet-string-icons--player__UBkwx`,
	"sheet-string-icons__subscription-tag": `sheet-string-icons__subscription-tag__rn21J`,
	"sheet-string-icons__icon": `sheet-string-icons__icon__eCEe8`,
	"sheet-string-icons__label--player": `sheet-string-icons__label--player__zzrlE`,
	"sheet-providers": `sheet-providers__koiZt`,
	"sheet-providers__content": `sheet-providers__content__Gd_p_`,
	"sheet-providers__items": `sheet-providers__items__qXo8T`,
	"sheet-providers__item": `sheet-providers__item__F2c1B`,
	"sheet-providers__item-content": `sheet-providers__item-content__JLkli`,
	"sheet-providers__item-image": `sheet-providers__item-image__DV3tT`,
	"sheet-providers__item-details": `sheet-providers__item-details__SQmtm`,
	"sheet-providers__item-npvr-icon": `sheet-providers__item-npvr-icon__vHaNj`,
	"sheet-providers__item-npvr-text": `sheet-providers__item-npvr-text__rOMOi`,
	"sheet-spacer": `sheet-spacer__YTILP`
};
export default ___CSS_LOADER_EXPORT___;
